import React from 'react'
import {
    Text,
    View,
    ActivityIndicator
} from 'react-native'

import styles from './styles'

import CONSTANTS from '../../constants/constants'
import {
    transDateFormat,
    currencyFormat,
    returnValueOrZero
} from '../../lib/index'

import Accordion from '../accordion/index'

const Listings = (props) => {
    const {
        isLoading,
        transactions,
        styleSize1,
        styleSize2
    } = props

    return (
        <View style={{ justifyContent:'flex-end', alignSelf: 'stretch' }}>
            {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'} />}

            {!isLoading && <Accordion
                sections={transactions}
                renderHeader={(section, key, active) => {
                    let context_date = !section.transaction_context.transaction_date
                                        ? section.pub_date
                                        : section.transaction_context.transaction_date

                    let invest = 0
                    if (section.hasOwnProperty('cashback_value')) {
                        invest = section.cashback_value
                    } else if (section.hasOwnProperty('refund')) {
                        invest = section.refund
                    }

                    return(
                        <View key style={[
                            styles.accHeaderContent,
                            active && styles.accHeaderContentActive,
                            key && styles.accHeaderLine
                        ]}>
                            <View style={styles.accHeaderMain}>
                                <View style={styles.accHeaderType}>
                                    {'new' === section.transaction_kind.toLowerCase()
                                        ? <View style={[styles.symbols, styles.symbolNew]}>
                                                <Text style={styles.symbolText}>N</Text>
                                            </View>
                                        : <View style={[styles.symbols, styles.symbolRecurring]}>
                                                <Text style={styles.symbolText}>R</Text>
                                            </View>}
                                </View>
                                <View style={styles.accHeaderMainView}>
                                    <Text style={[styles.accHeaderMainText1, styleSize1 ]}>
                                        {transDateFormat(context_date)}
                                    </Text>
                                    <Text style={[styles.accHeaderMainText2, styleSize2 ]}>
                                        {CONSTANTS.CARD_TYPES[section.card_type]}
                                        {'  '}
                                        {section.last_four}
                                        {'  '}
                                        {currencyFormat(returnValueOrZero(section.transaction_value))}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.accHeaderValue}>
                                <Text style={[styles.accHeaderValueText, styleSize1]}>
                                    {currencyFormat(returnValueOrZero(invest) + returnValueOrZero(section.fee))}
                                </Text>

                                <Text style={[styles.accHeaderMainText2, styleSize2]}>
                                    click for details
                                </Text>
                            </View>
                        </View>
                    )
                }}
                renderContent={(section, key, active) => {
                    let invest = 0
                    if (section.hasOwnProperty('cashback_value')) {
                        invest = section.cashback_value
                    } else if (section.hasOwnProperty('refund')) {
                        invest = section.refund
                    }

                    return(
                        <View key style={{ flexDirection: 'column', marginBottom: 10 }}>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-end' }}>
                                <Text style={[styles.accHeaderValueText2, styleSize2]}>
                                    Marketing Fee
                                </Text>
                                <Text style={[styles.accHeaderValueText2, styleSize2, { textAlign: 'right', marginLeft: 6 }]}>
                                    {currencyFormat(returnValueOrZero(section.fee))}
                                </Text>
                            </View>

                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-end', marginVertical: 5 }}>
                            <Text style={[styles.accHeaderValueText2, styleSize2]}>
                                    Cashback
                                </Text>
                                <Text style={[styles.accHeaderValueText2, styleSize2, { textAlign: 'right', marginLeft: 6 }]}>
                                    {currencyFormat(returnValueOrZero(invest))}
                                </Text>
                            </View>
                        </View>
                    )
                }}
            />}
        </View>
    )
}

export default Listings



// WEBPACK FOOTER //
// ./src/components/listings/index.js